import React from "react";
import styled from "./About.module.css";
import img1 from "./portfolio image.png";

const About = () => {
  return (
    <div id="about" className={styled.section}>
      <h2 className={styled.heading}>
        <span className={styled.accent}>About</span> Me
      </h2>

      <div className={styled.flex}>
        <div className={styled.div1}>
          <p className={styled.lead}>
            I'm a highly resourceful and passionate Full Stack Web Developer
            who enjoys turning business requirements into clean, reliable
            software — from client-facing websites to internal ERP systems
            that companies run their operations on.
          </p>
          <p>
            Passionate about creating a positive user experience, I enjoy
            working with and adapting to new technologies as they develop,
            and I care about writing code that's maintainable long after
            launch.
          </p>
          <p>
            I build for web platforms, work closely with businesses of all
            sizes, and I'm always looking for the next interesting problem
            to solve.
          </p>
        </div>
        <div className={styled.div2}>
          <img className={styled.img} src={img1} alt="Md Miftahul Islam" />
        </div>
      </div>
    </div>
  );
};

export default About;
